var _a;
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { UserRoles } from './domain/Models';
i18n.use(initReactI18next)
    .init({
    resources: {
        en: {
            general: {
                lotus: 'Lotus',
                user: 'User',
                email_address: 'Email address',
                password: 'Password',
                password_repeat: 'Password (repeat)',
                log_in: 'Log in',
                log_out: 'Log out',
                prize_schemes: 'Prize schemes',
                add_prize: 'Add prize',
                add_prize_scheme: 'Add prize scheme',
                title: 'Title',
                add: 'Add',
                edit: 'Edit',
                cancel: 'Cancel',
                reset: 'Reset',
                delete: 'Delete',
                save: 'Save',
                prize_scheme: 'Prize scheme',
                draws: 'Draws',
                prizes: 'Prizes',
                prize: 'Prize',
                options: 'Options',
                value: 'Value',
                move_up: 'Move up',
                move_down: 'Move down',
                general: 'General',
                matches: 'Matches',
                edit_prize_scheme: 'Edit prize scheme',
                add_draw: 'Add draw',
                draw: 'Draw',
                draw_category: 'Draw category',
                draw_mechanism: 'Draw mechanism',
                draw_at: 'Draw at',
                cutoff_at: 'Cut-off at',
                upcoming: 'Upcoming',
                verified: 'Verified',
                participations: 'Participations',
                participants: 'Participants',
                execute: 'Execute',
                verify: 'Verify',
                reject: 'Reject',
                ticket_number: 'Ticket number',
                results: 'Results',
                result: 'Result',
                executed_at: 'Executed at',
                rejected_at: 'Rejected at',
                verified_at: 'Verified at',
                synced_at: 'Synced at',
                draw_result: 'Draw result',
                position: 'Position',
                status: 'Status',
                ticket: 'Ticket',
                prizes_for_draw_result: 'Prizes for result',
                type: 'Type',
                ticket_type: 'Ticket type',
                ticket_types: 'Ticket types',
                awaiting_verification: 'Awaiting verification',
                payout: 'Payout',
                payment: 'Payment',
                edit_draw: 'Edit draw',
                search: 'Search',
                created_at: 'Created at',
                active_customers: 'Active customers',
                active_tickets: 'Active tickets',
                active_participations: 'Active participations',
                revenue: 'Revenue',
                total_winnings: 'Total winnings',
                system_time: 'System time',
                system_version: 'System version',
                rng_version: 'RNG version',
                rng_run: 'RNG run',
                less: 'Less',
                result_id: 'Result ID',
                ticket_structure: 'Ticket structure',
                tickets: 'Tickets',
                won_prizes: 'Won prizes',
                winnings: 'Winnings',
                guaranteed: 'Guaranteed',
                not_applicable_short: 'N/A',
                draw_at_description: 'The date and time at which this draw should be executed.',
                cutoff_at_description: 'The final date and time until which tickets can be purchased and paid for in order to participate in this draw. Should be before the draw date.',
                prize_scheme_description: 'The prize scheme from which prizes will be selected.',
                prize_scheme_guaranteed_description: 'All prizes in the prize scheme are guaranteed.',
                draw_category_description: 'Determines which tickets will be participating in this draw.',
                prize_title_description: 'The title of the prize that can be won.',
                prize_value_description: 'The value of the prize to the winner.',
                prize_matches_description: 'Select the positions of the ticket number that need to match a draw result in order to win this prize.',
                prize_distributor_description: 'The way this prize will be distributed to winners.',
                distributor: 'Distributor',
                distributors: 'Distributors',
                dashboard: 'Dashboard',
                years_count: '{{ count }} year',
                years_count_plural: '{{ count }} years',
                months_count: '{{ count }} month',
                months_count_plural: '{{ count }} months',
                days_count: '{{ count }} day',
                days_count_plural: '{{ count }} days',
                hours_count: '{{ count }} hour',
                hours_count_plural: '{{ count }} hours',
                minutes_count: '{{ count }} minute',
                minutes_count_plural: '{{ count }} minutes',
                seconds_count: '{{ count }} second',
                seconds_count_plural: '{{ count }} seconds',
                execute_draw: 'Execute draw',
                tickets_count: '{{ formatted_count }} ticket',
                tickets_count_plural: '{{ formatted_count }} tickets',
                execute_draw_description: 'This draw is ready for execution. The draw mechanism is <strong>{{ draw_mechanism }}</strong> and <strong>{{ tickets }}</strong> will have a chance to win a prize from prize scheme <strong>{{ prize_scheme }}</strong>. After executing the draw, you will have to verify or reject the draw result.',
                attempts_count: '{{ count }} attempt',
                attempts_count_plural: '{{ count }} attempts',
                attempt: 'Attempt',
                continue: 'Continue',
                confirm: 'Confirm',
                confirm_execute_draw: 'Execute this draw?',
                confirm_verify_draw: 'Verify this draw?',
                confirm_reject_draw: 'Reject this draw?',
                base_probability: 'Base probability',
                win_probability: 'Win probability',
                expected_winnings: 'Expected winnings',
                export: 'Export',
                draw_result_awaiting_verification: 'This draw result is awaiting verification.',
                draw_result_awaiting_verification_description: 'The result will become permanent after verification. This cannot be undone. If there is a problem with the result, do not verify it, but contact the lottery manager to reject it. After rejecting, the draw can be executed again.',
                prize_analysis: 'Prize analysis',
                count: 'Count',
                total_value: 'Total value',
                customer: 'Customer',
                customers: 'Customers',
                previous: 'Previous',
                next: 'Next',
                first: 'First',
                last: 'Last',
                plus_inactive_count: '+ {{ count }} inactive',
                source: 'Source',
                external_customer_id: 'External customer ID',
                external_ticket_id: 'External ticket ID',
                external_payment_id: 'External payment ID',
                unit_price: 'Unit price',
                selling_price: 'Selling price',
                active: 'Active',
                payments: 'Payments',
                external_id: 'External ID',
                amount: 'Amount',
                paid_at: 'Paid at',
                session_expired_description: 'Your session has expired. Please log in.',
                server_error_description: 'Sorry, something went wrong. Please try again later.',
                unauthorized_description: 'You are not authorized to perform this action.',
                throttled_description: 'Too many attempts. Please try again later.',
                prize_distributor: 'Prize distributor',
                confirm_delete: 'Delete {{ title }}?',
                actor: 'Actor',
                entity: 'Entity',
                event: 'Event',
                history: 'History',
                time: 'Time',
                prize_distributors: 'Prize distributors',
                prize_distribution: 'Prize distribution',
                net_amount: 'Net amount',
                tax_amount: 'Tax amount',
                download: 'Download',
                distributable_prizes: 'Distributable prizes',
                distributable_tickets: 'Distributable tickets',
                distributable_amount: 'Distributable amount',
                distribute: 'Distribute',
                confirm_distribute: 'Distribute {{ count }} prize for {{ title }}?',
                confirm_distribute_plural: 'Distribute all {{ count }} prizes for {{ title }}?',
                credit_transfer_files: 'Credit transfer files',
                credit_transfers: 'Credit transfers',
                last_distributed_at: 'Last distributed at',
                distributed: 'Distributed',
                undistributed: 'Undistributed',
                creditor_name: 'Creditor name',
                creditor_iban: 'Creditor IBAN',
                payout_iban: 'Payout IBAN',
                distributed_draw: 'Distributed draw',
                distributed_ticket: 'Distributed ticket',
                distributed_tickets: 'Distributed tickets',
                checksum: 'Checksum',
                unknown: 'Unknown',
                values: 'Values',
                options_count: '{{ count }} option',
                options_count_plural: '{{ count }} options',
                invalid_token: 'The link you followed is no longer valid.',
                create_password: 'Create password',
                please_create_password: '{{ name }}, please create a password',
                name: 'Name',
                email: 'E-mail',
                role: 'Role',
                users: 'Users',
                email_verified_at: 'E-mail verified at',
                forgot_password: 'Forgot password',
                reset_password: 'Reset password',
                password_reset_sent: 'Your password reset request has been received. If the provided e-mail address exists, you will receive an e-mail with further instructions.',
                reset_your_password: '{{ name }}, enter a new password',
                enter_tfa_code: '{{ name }}, enter your login code',
                setup_tfa_instructions: 'Please set up two-factor authentication to continue. Scan the QR code with an authenticator app on your personal device, such as Authy or Google Authenticator. Next, enter the generated 6-digit PIN that is being shown on the screen. The next time you log in, you will need to have access to the same device and authenticator app to continue.',
                go_back: 'Go back',
                code: 'Code',
                none: 'None',
                properties: 'Properties',
                prize_properties_description: 'Extra (technical) info about the prize.',
                hiding_prizes_x_to_y: 'Hiding prizes {{ x }} – {{ y }}',
                show_all: 'Show all',
                draw_mechanism_description: "The way in which winning tickets are drawn."
            },
            draw_statuses: {
                open: 'Open',
                closed: 'Closed',
                syncing: 'Syncing',
                pending: 'Pending',
                verified: 'Verified'
            },
            payment_statuses: {
                cancelled: 'Cancelled',
                paid: 'Paid',
                refunded: 'Refunded',
                reversed: 'Reversed'
            },
            validation: {
                required: '{{ attribute }} is required.',
                invalid: '{{ attribute }} is invalid.',
                before: '{{ attribute }} should be before {{ date }}.',
                after: '{{ attribute }} should be after {{ date }}.',
                min_list: '{{ attribute }} should contain at least {{ min }} items.',
                min_string: '{{ attribute }} should be at least {{ min }} characters.',
                max_list: '{{ attribute }} should contain at most {{ max }} items.',
                max_string: '{{ attribute }} should be at most {{ max }} characters.',
                gt: '{{ attribute }} should be more than {{ min }}.',
                gte: '{{ attribute }} should be least {{ min }}.',
                lt: '{{ attribute }} should be less than {{ max }}.',
                lte: '{{ attribute }} should be at most {{ max }}.',
                ip_not_whitelisted: 'You are not allowed to perform this action from your location.',
            },
            auditor: {
                attached: 'Attached',
                created: 'Created',
                deleted: 'Deleted',
                detached: 'Detached',
                initialized: 'Initialized',
                updated: 'Updated'
            },
            events: {
                attached: 'attached',
                created: 'created',
                deleted: 'deleted',
                detached: 'detached',
                initialized: 'initialized',
                updated: 'updated',
                login: 'logged in',
                failed_login: 'failed login',
                login_blocked: 'failed login (blocked)',
                tfa_setup: 'set up 2FA',
                tfa_failed: 'entered invalid 2FA code',
                tfa_success: 'entered valid 2FA code',
                exported: 'exported',
                password_reset_request: 'requested password reset'
            },
            morph_types: {
                credit_distributions: 'Credit distribution',
                draw_mechanisms: 'Draw mechanism',
                draw_results: 'Draw result',
                draws: 'Draw',
                lotteries: 'Lottery',
                prize_distributions: 'Prize distribution',
                prize_distributors: 'Prize distributor',
                prize_schemes: 'Prize scheme',
                prizes: 'Prize',
                rsus: 'RSU',
                ticket_distributions: 'Ticket distribution',
                users: 'User',
            },
            roles: (_a = {},
                _a[UserRoles.Manager] = 'Manager',
                _a[UserRoles.Notary] = 'Notary',
                _a[UserRoles.Finance] = 'Finance',
                _a[UserRoles.Viewer] = 'Viewer',
                _a)
        }
    },
    lng: 'en',
    fallbackLng: 'en',
    defaultNS: 'general',
    interpolation: {
        escapeValue: false
    }
});
export default i18n;
